import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/services/shared.service';
import { AdministrationService } from 'src/app/services/administration.service';
import { MatSnackBar, MatDialogRef, MatDialog, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { EventRank } from 'src/app/models/eventsDto';
import { ProgressSpinnerDialogComponent } from 'src/app/progress-spinner-dialog/progress-spinner-dialog.component';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-events-rank',
  templateUrl: './events-rank.component.html',
  styleUrls: ['./events-rank.component.scss']
})
export class EventsRankComponent implements OnInit {

  eventId: number;
  id: number;

  form: FormGroup;
  dialogRef: MatDialogRef<ProgressSpinnerDialogComponent>;
  event: EventRank;
  userRole: string;

  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private adminService: AdministrationService,
    private snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog, private authService: AuthenticationService) { }

  ngOnInit() {
    this.id = +this.route.snapshot.paramMap.get('id').toString();
    this.eventId = +this.route.snapshot.paramMap.get('eventId').toString();
    this.userRole = this.authService.getUserRole();
    this.buildForm();
    if (this.id > 0){
      this.dialogRef = this.dialog.open(ProgressSpinnerDialogComponent, {
        panelClass: 'transparent',
        disableClose: true
      });
      this.adminService.GetEventRankById(this.id).subscribe((result: EventRank) => {
        this.dialogRef.close();
        this.event = result;
        this.updateForm();
      }, error => {
        this.dialogRef.close();
      });
    }

  }

  buildForm() {
    this.form = this.fb.group({
      eventId: new FormControl(this.eventId),
      id: new FormControl(this.id),
      name: new FormControl('', [Validators.required]),
      price: new FormControl(0, [Validators.required])
    });
  }

  updateForm() {
    this.form.setValue({
      id: this.id,
      eventId: this.eventId,
      name: this.event.name,
      price: this.event.price
    });
  }

  onBackClick() {
    this.router.navigate(['/events/'+ this.eventId]);
  }

  onSubmit() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.AddOrUpdateEventRank(this.form.value).subscribe(res => {
     // this.onBackClick();
      dialogRef.close();
      this.snackBar.open(this.eventId === -1 ? 'event created.' : 'event updated.', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open(this.eventId === -1 ? 'Error creating event.' : 'Error updating event.', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  onDelete() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.RemoveEvent(this.eventId).subscribe(res => {
      dialogRef.close();
      this.router.navigate(['/events/'], { relativeTo: this.route });
      this.snackBar.open('Member Deleted', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open('Error deleting member', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }



}
